import React from 'react';
import { ScommessaTipoGroup } from 'components/scommesseTipo/scommesseTipoGroup/ScommessaTipoGroup';
import { SportScommesseRenderConditional } from 'features/sport/components/sportScommesseRenderConditional';
import styles from './ScommesseTipoList.module.scss';
import classNames from 'classnames';
import { useIsAvvenimento } from 'features/sport/hooks';

export type ScommessaTipoListProps = {
  avvenimentoKey: string;
  isTooltipClicked?: boolean;
  isVisualizzazioneEstesa: boolean;
  infoTipoScommessaKeyStringList: Array<string>;
  setIsTooltipClicked?: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ScommesseTipoList = ({
  avvenimentoKey,
  isTooltipClicked,
  isVisualizzazioneEstesa,
  infoTipoScommessaKeyStringList,
  setIsTooltipClicked,
}: ScommessaTipoListProps) => {
  const isAvvenimento = useIsAvvenimento();
  const hasMultipleScommesse = infoTipoScommessaKeyStringList.length > 1;

  return (
    <React.Fragment key={avvenimentoKey}>
      {infoTipoScommessaKeyStringList?.map((infoTipoScommessaKey) => {
        if (infoTipoScommessaKey.startsWith('group-')) {
          return (
            <ScommessaTipoGroup
              key={infoTipoScommessaKey}
              avvenimentoKey={avvenimentoKey!}
              scommessaGroupKey={infoTipoScommessaKey}
              isVisualizzazioneEstesa={isVisualizzazioneEstesa}
              setIsTooltipClicked={setIsTooltipClicked}
              isTooltipClicked={isTooltipClicked}
              className={classNames({
                [styles.avvenimentoContainer]: isAvvenimento && hasMultipleScommesse,
              })}
            />
          );
        }

        const scommessaKey = `${avvenimentoKey}-${infoTipoScommessaKey}`;
        return (
          <SportScommesseRenderConditional
            key={scommessaKey}
            length={infoTipoScommessaKeyStringList.length}
            hasTitle={infoTipoScommessaKeyStringList.length > 1}
            hasHeader
            isEstesa={isVisualizzazioneEstesa}
            scommessaKey={scommessaKey}
            containerClassName={classNames(styles.block, {
              [styles.avvenimentoContainer]: isAvvenimento && hasMultipleScommesse && !isVisualizzazioneEstesa,
            })}
            setIsTooltipClicked={setIsTooltipClicked}
            isTooltipClicked={isTooltipClicked}
          />
        );
      })}
    </React.Fragment>
  );
};

export default ScommesseTipoList;
